import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { SideNav } from '../../components/fs';
import { MeResponse, adminMe } from '../../api/admin';
import { settingsNavGroups } from '../../shared/settingsNav';

/**
 * The Settings shell (R10, screens 25–36): rail + content, edge to edge
 * (playbook §1a). AdminLayout renders every /admin/settings/* route
 * full-bleed; this draws the 236px grouped `SideNav` on the left and beside
 * it the padded page (`20px clamp(16px, 2.4vw, 32px)`), where each page's
 * cards sit left at their natural width — never in a centred column.
 *
 * The groups and who sees which page live in shared/settingsNav.ts, the one
 * list the ⌘K palette reads too. Pages are ABSENT rather than disabled for
 * anyone who may not use them; the server refuses each route either way.
 *
 * Under 900px the SideNav is one scrolling chip row above the page (its own
 * phone branch), so the rail never squeezes the content.
 */
export default function SettingsLayout() {
  const [me, setMe] = useState<Pick<MeResponse, 'admin' | 'features' | 'isPlatformAdmin'> | null>(null);

  useEffect(() => {
    adminMe()
      .then((r) => setMe({ admin: r.admin, features: r.features, isPlatformAdmin: !!r.isPlatformAdmin }))
      .catch(() => undefined);
  }, []);

  return (
    <div className="st-page">
      <aside className="st-side">
        {me && <SideNav groups={settingsNavGroups(me)} aria-label="Settings" />}
      </aside>
      <div className="st-main">
        <Outlet />
      </div>
    </div>
  );
}
